<template>
  <b-row class="input-contain mb-3">
    <b-col v-if="labelLink" cols="12" md="12" class="text-right pb-2">
      <router-link
        :to="{ name: labelLink.routeName }"
        class="font_16 label_link"
        v-text="labelLink.caption"
      />
    </b-col>
    <b-col cols="12" md="12" class="captcha_style_input">
      <b-form-textarea
        v-if="type === 'textarea'"
        v-model="inputValue"
        :id="id"
        :rows="textareaRows"
        :autocomplete="autocomplete"
        :disabled="disabled"
        :state="state"
        :aria-describedby="`${id}-help ${id}-feedback`"
        trim
        class="input"
      />
      <b-form-input
        v-else
        v-model="inputValue"
        :type="type"
        :id="id"
        :minLength="minLength"
        :maxLength="maxLength"
        :autocomplete="autocomplete"
        :disabled="disabled"
        :state="state"
        :aria-describedby="`${id}-help ${id}-feedback`"
        trim
        class="input"
      />
      <label :for="id" :id="id">
        <div class="text" v-text="label" />
        <!-- <span v-if="requiredStar" class="required_star" /> -->
      </label>
      <span
        v-if="type === 'password'"
        class="show_password"
        @click="showPassword()"
      >
        <mdicon name="eye-off-outline" size="20" />
      </span>
      <div
        v-if="hasPasswordGuidance && type === 'password'"
        class="text-left text-info d-flex align-items-center"
      >
        <mdicon name="information" size="15" class="mr-1" /><small
          v-text="$lang.password_template"
        />
      </div>
    </b-col>
    <b-col cols="12" md="12" class="text-left mt-1">
      <FeedbackMessages
        :state="state"
        :label="label"
        :vuelidateObj="vuelidateObj"
      />
    </b-col>
  </b-row>
</template>

<script>
import FeedbackMessages from "./FeedbackMessages.vue";
import { includes } from "ramda";

export default {
  components: {
    FeedbackMessages,
  },
  props: {
    value: {}, // watch model
    name: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "عنوان",
    },
    id: {
      type: String,
      default: "default-id",
    },
    labelLink: {
      type: [Object, Boolean],
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    textareaRows: {
      type: Number,
      default: 3,
    },
    placeholder: {
      type: String,
      default: "",
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    state: {
      type: Boolean,
      default: null,
    },
    vuelidateObj: {
      type: Object,
      default: null,
    },
    requiredStar: {
      type: Boolean,
      default: false,
    },
    minLength: {
      type: [String, Number],
      default: 1,
    },
    maxLength: {
      type: [String, Number],
      default: 256,
    },
    hasPasswordGuidance: {
      type: Boolean,
      default: false,
    },
    authInputs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputFontSize: "font_18",
    };
  },
  computed: {
    inputValue: {
      /* guidance: watching input value */
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", this.name, val);
      },
    },
  },
  mounted() {
    const input = document.getElementById(this.id);
    if (!includes(this.id, ["username", "password"])) {
      input.setAttribute("value", "");
    }
    input.addEventListener("keyup", () => {
      input.setAttribute("value", input.value);
    });
  },
  methods: {
    includes,
    showPassword() {
      /* guidance: toggle change type of password input (when clicked eye icon) */
      if (includes(this.type, ["text", "password"])) {
        const el = document.getElementById(this.id);
        document.getElementById(this.id).type =
          el.type === "password" ? "text" : "password";
        this.inputFontSize = el.type === "password" ? "font_25" : "font_18";
      }
    },
  },
};
</script>
